module.exports = {
  en: {
    "home": "Main Menu",
    "showNarration": "Show",
    "hideNarration": "Hide",
    "narrationCaption": "Narration",
    "pause": "Pause audio",
    "resume": "Resume audio",
    "replay": "Replay audio",
    "reload": "Replay audio",
    "play": "Play",
    "muteOn": "Turn Audio On",
    "muteOff": "Turn Audio Off",
    "mute": "Mute",
    "transcriptClose": "Close transcript",
    "portraitModeWarning": "This course is optimized on mobile to be viewed in landscape mode, please try rotating your device.",
    "okButton": "OK",
    "secondaryNavigationLabel": "Secondary Navigation",
    "backButton": "Previous Page",
    "forwardPopover": "Page is done, time to go to the next one!",
    "forwardButton": "Next Page",
    "portfolioButton": "Portfolio",
    "portfolioButtonOpen": "Close Portfolio",
    "surveyRedirectLocal": "If you weren't local you'd be redirected to survey",
    "clickToProceed": "Click Here to Proceed",
    "assessmentRedirect": "You are being directed to an assessment.",
    "surveyAlreadyCompleted": "You have already completed this survey",
    "surveyRedirect": "You are being directed to a survey.",
    "surveyRedirectText": "If you are not directed in 5 seconds",
    "surveyRedirectLinkText": "click here",
    "srSkipText": "Press shift plus control plus {{accessibility.skipKey}} to continue to the next page when you are ready.",
    "clickToSign": "Click to e-sign (required)",
    "signedMessage": "Thanks for signing!",
    "defaultESigBody": "Click the link above before e-signing.",
    "videoKeyboardShortcutsButton": "Keyboard Shortcuts",
    "videoKeyboardShortcuts": "<p>Use Space or Enter to pause/play the video.</p><p>Use M to mute/unmute the video.</p><p>Use Up Arrow and Down Arrow to increase/decrease the volume.</p><p>Use C to show/hide the captions.</p>",
    "videoKeyboardShortcutsClose": "Close",
    "submitbtn": "Submit",
    "closeModal": "Close",
    "close_resource_btn": "close",
    "mediaAccessibility": {
      "completed": "Media completed, click to Replay",
      "playing": "Media playing, click to Pause",
      "stopped": "Media stopped, click to Play",
      "paused": "Media stopped, click to Play",
      "none": "Media unavailable"
    },
    "audioAccessibility": {
      "playing": "Audio Playing, Select to Pause",
      "paused": "Audio Paused, Select to Play",
      "stopped": "Audio Stopped, Select to Play",
      "completed": "Audio Complete, Select to Replay"
    },
    "videoAccessibility": {
      "pause": "Select this button to pause the video",
      "play": "Select this button to play the video",
      "stopped": "Video stopped, click to play",
      "playpause": "Click to pause or play media",
      "start": "Click to start",
      "mute": "Select this to mute the video",
      "unmute": "Select this to unmute the video",
      "time": "Current media time",
      "seeker": "Fast forward or rewind current media",
      "duration": "Media duration",
      "captions": "Toggle media captions",
      "volumebar": "Adjust volume of media",
      "tracks": "Switch A/V tracks in media",
      "bitrate": "Switch bitrate of media",
      "fullscreen": "Toggle fullscreen of media",
      "keyboardShortcutsButton": "Keyboard Shortcuts",
      "keyboardShortcuts": "<p>Use Space or Enter to pause/play the video.</p><p>Use M to mute/unmute the video.</p><p>Use Up Arrow and Down Arrow to increase/decrease the volume.</p><p>Use C to show/hide the captions.</p>",
      "keyboardShortcutsClose": "Close",
      "playerInstructions1": "This is a video player on ",
      "playerInstructions2": "Use Space or Enter to pause/play the video. Use M to mute/unmute the video. Use C to show/hide the captions. Use F to go Fullscreen. Use Up Arrow and Down Arrow to increase/decrease the volume. Use Right Arrow and Left Arrow to skip forward/backward."
    },
    "audioFailedAlert": "An audio file failed to start, use this button to try restarting it:",
    "startAudioButton": "Start Audio",
    "actionPlan": {
      "viewMyPlan": "Continue",
      "summaryText": "Congratulations on completing your Action Plan! Select Continue to view your plan and have it emailed to you.",
      "stepDone": "Done",
      "completeTitle": "Action Plan Complete",
      "sendEmail": "Email me my action plan",
      "emailErrorMessage": "Please enter a valid email address.",
      "emailPlaceholder": "email address",
      "subheader": "Building Action Plan",
      "stepsComplete": "Step {{currentStep}} of {{totalSteps}}"
    },
    "actionPlanResponses": {
      "subheader": "Viewing Action Plan",
      "stepsComplete": "{{doneTotal}} of {{responseTotal}} complete",
      "now": "now",
      "later": "later",
      "done": "Done",
      "incomplete": "Please finish the module in order to build your Action Plan."
    },
    "dragAndDrop": {
      "single": "This is a draggable element. You can also use the keyboard to make selections - press ENTER to move this item to the correct drop spot.",
      "multiple": "This is a draggable element. If you would like to move draggable elements using a keyboard: press tab key to move among elements, press the enter key to select an element, and then press the {{firstOption}} or {{lastOption}} keys to move and the drop the element.",
      "default": "Drop spot",
      "linkWord": "for",
      "dropped": "This draggable element is now dropped.",
      "dropSpotTaken": "Drop spot already taken.",
      "success": "Drag element dropped successfully.",
      "incorrect": "Drag element not dropped. Incorrect drop spot."
    },
    "moduleProgress": "{{completedModules}} out of {{totalModules}}"
  },
  es: {
    "transcriptClose": "Cerrar la transcripción",
    "backButton": "Pagina Anterior",
    "forwardButton": "Siguiente Página",
    "portraitModeWarning": "Este curso está optimizado para verse en modo apaisado en teléfonos móviles. Por favor, intente rotar su teléfono.",
    "secondaryNavigationLabel": "Navegación secundaria",
    'closeModal': 'Cerrar',
    "actionPlan": {
      "viewMyPlan": "Continue",
      "summaryText": "Congratulations on completing your Action Plan! Select Continue to view your plan and have it emailed to you.",
      "stepDone": "Done",
      "completeTitle": "Plan de Acción completo",
      "sendEmail": "Mándame por correo electrónico mi plan de acción",
      "emailPlaceholder": "correo electrónico",
      "subheader": "Montar un Plan de Acción",
      "stepsComplete": "Step {{currentStep}} of {{totalSteps}}"
    },
    "actionPlanResponses": {
      "subheader": "Viewing Action Plan",
      "stepsComplete": "{{doneTotal}} of {{responseTotal}} complete",
      "now": "Ahora",
      "later": "Más tarde",
      "done": "Bien",
      "incomplete": "Ver el plan de acción"
    },
    "dragAndDrop": {
      "single": "Este es un elemento arrastrable. También puede usar el teclado para hacer selecciones: presione ENTER para mover este elemento al lugar de colocación correcto.",
      "multiple": "Este es un elemento arrastrable. También puedes usar el teclado para hacer selecciones: presiona ENTER para seleccionarlo, luego presiona una tecla de {{primera opción}} a {{última opción}} para mover este elemento.",
      "default": "Lugar de caída",
      "linkWord": "para",
      "dropped": "Este elemento arrastrable ahora se descarta.",
      "dropSpotTaken": "Drop spot ya tomado.",
      "success": "Arrastrar elemento se cayó con éxito.",
      "incorrect": "El elemento de arrastre no se ha caído. Punto de caída no correcto."
    },
    "videoAccessibility": {
      "pause": "Selecciona este botón para pausar el video",
      "play": "Seleccione este botón para reproducir el video",
      "stopped": "Video detenido, haga clic para reproducir",
      "playpause": "Haga clic para pausar o reproducir medios",
      "mute": "Seleccione esto para silenciar el video",
      "unmute": "Seleccione esto para dejar de silenciar el video",
      "time": "Tiempo de medios actual",
      "seeker": "Avanzar o rebobinar los medios actuales",
      "duration": "Duración de los medios",
      "captions": "Alternar subtítulos multimedia",
      "volumebar": "Ajustar el volumen de los medios",
      "tracks": "Cambie las pistas A / V en los medios",
      "bitrate": "Cambiar la tasa de bits de los medios",
      "fullscreen": "Alternar pantalla completa de medios",
      "keyboardShortcutsButton": "Atajos de teclado",
      "keyboardShortcuts": "<p>Use la barra espaciadora o Enter para pausar/reproducir el video.</p><p>Use M para silenciar/activar el sonido del video.</p><p>Use la flecha hacia arriba y la flecha hacia abajo para subir/bajar el volumen.</p><p>Usa C para mostrar/ocultar los subtítulos.</p>",
      "keyboardShortcutsClose": "Cerrar",
      "playerInstructions1": "Este es un reproductor de video en ",
      "playerInstructions2": "Use la barra espaciadora o Enter para pausar / reproducir el video. Use M para silenciar / activar el sonido del video. Use C para mostrar / ocultar los subtítulos. Use F para ir a pantalla completa. Use la flecha arriba y la flecha abajo para aumentar / disminuir el volumen. Use la flecha derecha y la flecha izquierda para saltar hacia adelante / atrás."
    }
  }
};
